import { ApiJobFunction } from 'api/types/ApiJobFunction';
import { getJson } from 'utils/http';

export function apiFetchInternshipFunctions(): Promise<ApiJobFunction[]> {
  return getJson(
    `/data/website/internship-functions?lang=${CURRENT_LOCALE}`,
    // @ts-expect-error TS(2345): Argument of type '({ internshipFunctions }: { inte... Remove this comment to see the full error message
  ).then(({ internshipFunctions }) => internshipFunctions);
}
